<!--
 * @Author: your name
 * @Date: 2021-11-25 14:55:54
 * @LastEditTime: 2025-10-30 16:17:57
-->
<template>
  <div class="pages">
    <h1 class="title" style="margin-bottom: 10px;">丰巢寄件服务协议</h1>
    <p class="sub_text btd">修订时间：2024年8月9日</p>
    <p class="sub_text btd">生效时间：2024年8月16日</p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;"
        >欢迎用户（以下称“您”）与深圳市丰巢科技有限公司、丰巢网络技术有限公司及关联公司（以下称“丰巢”）共同签署《寄件服务协议》（下称“本协议”）并使用丰巢寄件服务平台提供的智能柜寄件、快递员上门寄件或服务站寄件等技术服务（下称“本服务”），由最终快递承运公司向您提供快递运输服务。</span
      >
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;"
        >本协议由您和丰巢共同缔结，深圳市丰巢科技有限公司提供系统、软件技术服务，丰巢网络技术有限公司提供有偿末端支持服务（包括但不限于智能快件箱硬件设备、消息推送、查询服务、运维服务、视频监控服务、客服服务），本协议对您和丰巢具有约束力。在使用本服务时，请您遵守本协议约定的各项规则和义务。您在阅读本协议时，请确保已了解各条款含义，尤其文字加粗、标红部分，请您慎重阅读。如您对协议有任何疑问，可向丰巢客服（电话：95333）咨询。</span
      >
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:12px;display: block;">
        当您进入寄件订单信息填写页面时请按页面提示填写信息，当您勾选同意本协议、点击“下单”后，即表示您已充分阅读、理解并接受本协议的全部内容。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止使用寄件服务。
      </span>
    </p>

    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        一、特别声明
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span class="fontb" style="color: #000000; font-family: 宋体;display: block;">
        1、丰巢为您提供智能快件箱等末端支持服务及线上下单、查询等技术服务，快件寄递服务将由最终承运的快递服务公司为您提供，丰巢自始不属于“快递公司”，因快递承运服务导致的快递合同及服务质量纠纷，丰巢将积极协助您与快递公司自行解决。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        依据《智能快件箱寄递服务管理办法》，“智能柜寄件”服务模式下，丰巢属于具备接手交寄物品功能的智能快件箱运营企业，依法为快递公司履行实名收寄义务提供技术条件和技术服务，但您需同意并理解，快递公司需独立向您承担法律责任并依法履行保障快递安全、保护快递用户（“您”）合法权益的法定义务。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        2、本服务为自助式服务，您在使用本服务前，请根据要求完整填写包裹信息并确保准确、真实，以便快递公司进行开箱验视，判断是否符合寄递要求。您将包裹放置于智能柜内不代表丰巢核实或认可包裹符合寄递条件，由快递公司对包裹进行核验，请您根据快递公司要求与反馈进行处理。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span class="fontb" style="color: #000000; font-family: 宋体;display: block;">
        3、您在使用本服务前请根据要求完成实名制认证，填写自身及收件人的身份信息（姓名或名称、地址、联系电话等）并确保准确、真实、有效。认证信息发生变更时，应及时更新。如因您填写的寄件信息不准确、无效或不完整，导致您下达的订单无法顺利履行（包括无法按时上门揽收、揽收后无法派送等），您应自行承担全部责任。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        4、根据国家寄递相关法规要求寄递人需实名寄递，同时实名寄递信息将同步推送至快递公司、邮政管理部门、公安机关等政府相关单位。当您勾选本协议并使用本服务时，即代表您同意丰巢使用您的个人身份信息（包含姓名、联系方式、证件号码、面部识别特征等个人信息），同时丰巢承诺不会擅自向任何第三方（前述主体除外）提供您的信息。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span class="fontb" style="color: #000000; font-family: 宋体;display: block;">
        5、在进行实名寄递认证时，需真实填写个人信息或完成实名核验程序。如通过盗取、冒用他人实名信息进行寄递的行为，丰巢将保留向国家相关单位检举、追责的权利，对造成重大影响、构成犯罪的行为，您应自行承担全部责任。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:12px;display: block;">
        6、您理解并同意，为响应快递行业隐私面单推广及寄递用户个人信息保护目的，丰巢倡导合作快递公司使用隐私面单，但实际运单形式以快递公司使用为准。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        二、定义
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        1、快递寄件服务：您在丰巢柜寄件、快递员上门、服务站寄件页面填写寄件信息并点击下单后，丰巢以技术手段向您选择的快递公司发出寄递包裹需求，快递公司指派寄件服务人员将按照您所填写的寄件订单信息进行物品揽收、寄递费用核算、回传运单号和物流信息，并将您委托寄递的物品配送至收件地址。
      </span><span class="fontb" style="color: #000000; font-family: 宋体;"
      >快递寄件服务指快递公司向您提供的寄件服务。</span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        2、丰巢寄件服务平台：指提供丰巢柜寄件或快递员上门寄件服务下单入口（含客户端软件和PC端网站）、丰巢智能快件箱的统称，您可以通过丰巢APP、小程序、微信公众号、官方网站结合丰巢智能快件箱使用快递寄件服务。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        3、快递公司：与丰巢建立技术合作关系的为您提供快递寄件服务的法律主体。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:12px;display: block;">
        4、关联公司：指丰巢互动媒体有限公司及其他受丰巢实际控制人同一控制、与丰巢有直接或间接股权关系的其他关联实体。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        三、丰巢为您提供的服务
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        1、丰巢通过丰巢寄件服务平台为您提供技术服务。您可以使用丰巢寄件服务平台填写寄件订单信息、对寄递物品在线保价、在线预估运费、发布订单信息、在线支付运费、查询相关快递公司（可查询的快递公司清单以丰巢寄件服务平台展示的为准）的物流信息等。“在线预估运费”是指丰巢将依据您预选的收寄件信息（包括距离及物品等）、格口大小、快递服务等情况，依照快递公司指定的运费价格，为您提供在线预估运费的技术服务。预估价格仅供参考，您理解，物品及包装后的重量、体积应以快递公司实际揽收称重为准，丰巢不应为以上价差承担任何赔偿责任。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        “超重补差价”是指当快递公司揽收计费后的实际运费超过您投柜时支付的预估运费时，将会产生超重部分（超过限定重量或体积），您需就超重部分向快递公司（或快递公司委托丰巢代为收取的）支付差价费用。超重部分的计费规则以最终快递服务公司的运费计费规则为准，您可通过快递公司官网、官方服务渠道或者快递员等方式了解具体计费规则。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        2、丰巢是技术服务提供方，您授权且认可丰巢以技术手段为您匹配可为您提供快递寄件服务的快递公司。您确认知晓寄递/运输的法律关系由您与快递公司建立，丰巢并不是寄递运输法律关系中的任何一方。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span class="fontb" style="color: #000000; font-family: 宋体;display: block;">
        3、丰巢并不保证在您期望的时间内一定会有快递公司的服务人员承接并处理您的寄件订单。即便接单后，丰巢也不对承接订单的快递公司向您实际提供的寄递服务的服务履约和服务质量承担任何保证和担保责任。对于收件方指定快递公司或高时效要求的包裹，请您使用“上门取”寄件服务。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      4、<span class="fontb" style="color: #e60012; font-family: 宋体;">
        转单服务是指当您发出的寄件订单超时未被您原本选定的快递公司接单时，为避免您的寄件订单失败而无法享受丰巢寄件服务，同时为了进一步提升您的寄件体验，丰巢将为您匹配其他快递公司承接订单并完成承运服务。您将包裹投柜后，可在寄件订单详情页选择同意/不同意转单。如您选择同意转单且您原本选定的快递公司未在规定时效内揽收，丰巢将会为您提供转单服务；如您选择不同意转单且您原本选定的快递公司未在规定时效内揽收，丰巢将在包裹入柜三日后取消该订单，请您及时取出包裹。
      </span><span style="color: #000000; font-family: 宋体;"
      >您知悉并同意，转单时具体承运的快递公司及转单信息以丰巢实际通知及产品界面展示为准。您无需为转单支付额外的费用。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        5、当您的包裹不符合快递公司的寄递要求而被快递公司拒收时，丰巢根据快递公司的拒收反馈向您发出通知，由您取回包裹。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        6、基于向您履行寄件合同所必需，丰巢需要将您下单时的物流订单信息共享给您所选择的快递公司，以便您完成寄件。共享信息的情况如下（具体接收方以产品实际页面中展示和您所选择的快递公司为准），更多详细信息可见《丰巢隐私政策》及《丰巢第三方信息共享清单》。
      </span>
    </p>

    <table border="1">
        <tr>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              接收方名称
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              联系方式
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              处理方式
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              个人信息种类
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              深圳顺丰泰森控股（集团）有限公司
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              95338
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              通过API方式共享
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;"
            >物流订单信息（包括收、寄件人姓名、</span
            ><span class="fontb" style="color: #000000; font-family: 宋体;"
            >地址</span
            ><span style="color: #000000; font-family: 宋体;"
            >、联系电话、</span
            ><span class="fontb" style="color: #000000; font-family: 宋体;"
            >寄件人身份证号码</span
            ><span style="color: #000000; font-family: 宋体;"
            >、快递服务类型、物品信息、付款方式）、保价信息（如有）、期望上门时间（如有）
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              中国邮政速递物流股份有限公司
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              11183
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              通过API方式共享
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;"
            >物流订单信息（包括收、寄件人姓名、</span
            ><span class="fontb" style="color: #000000; font-family: 宋体;"
            >地址</span
            ><span style="color: #000000; font-family: 宋体;"
            >、联系电话、</span
            ><span class="fontb" style="color: #000000; font-family: 宋体;"
            >寄件人身份证号码</span
            ><span style="color: #000000; font-family: 宋体;"
            >、快递服务类型、物品信息、付款方式）、保价信息（如有）
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              中通快递股份有限公司
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              95311
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              通过API方式共享
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;"
            >物流订单信息（包括收、寄件人姓名、</span
            ><span class="fontb" style="color: #000000; font-family: 宋体;"
            >地址</span
            ><span style="color: #000000; font-family: 宋体;"
            >、联系电话、</span
            ><span class="fontb" style="color: #000000; font-family: 宋体;"
            >寄件人身份证号码</span
            ><span style="color: #000000; font-family: 宋体;"
            >、快递服务类型、物品信息、付款方式）、期望上门时间（如有
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              申通快递有限公司
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              95543
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              通过API方式共享
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;"
            >物流订单信息（包括收、寄件人姓名、</span
            ><span class="fontb" style="color: #000000; font-family: 宋体;"
            >地址</span
            ><span style="color: #000000; font-family: 宋体;"
            >、联系电话、</span
            ><span class="fontb" style="color: #000000; font-family: 宋体;"
            >寄件人身份证号码</span
            ><span style="color: #000000; font-family: 宋体;"
            >、快递服务类型、物品信息、付款方式）
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              圆通速递有限公司
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              95554
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              通过API方式共享
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;"
            >物流订单信息（包括收、寄件人姓名、</span
            ><span class="fontb" style="color: #000000; font-family: 宋体;"
            >地址</span
            ><span style="color: #000000; font-family: 宋体;"
            >、联系电话、</span
            ><span class="fontb" style="color: #000000; font-family: 宋体;"
            >寄件人身份证号码</span
            ><span style="color: #000000; font-family: 宋体;"
            >、快递服务类型、物品信息、付款方式）
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              上海韵达货运有限公司
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              95546
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;display: block;">
              通过API方式共享
            </span>
          </td>
          <td>
            <span style="color: #000000; font-family: 宋体;"
            >物流订单信息（包括收、寄件人姓名、</span
            ><span class="fontb" style="color: #000000; font-family: 宋体;"
            >地址</span
            ><span style="color: #000000; font-family: 宋体;"
            >、联系电话、</span
            ><span class="fontb" style="color: #000000; font-family: 宋体;"
            >寄件人身份证号码</span
            ><span style="color: #000000; font-family: 宋体;"
            >、快递服务类型、物品信息、付款方式）
            </span>
          </td>
        </tr>
    </table>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:12px;display: block;">
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        四、您使用服务应遵守的规则
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        1、您通过丰巢寄件服务平台下单后，丰巢将匹配您选择的快递公司为您提供服务。若您选择快递员上门寄件服务的，您应等待在快递员上门前妥善整理您需要寄递的物品，并准备好您在下单页面填写的寄件人的有效身份证件，配合相关人员依法验视订单对应的寄递物品和寄件人身份证件。快递公司对您的寄递验视信息承担保密义务。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      2、<span class="fontb" style="color: #000000; font-family: 宋体;"
      >您应禁止向智能柜放置：国家法律法规明确禁止、限制寄递或流通的物品；重量超过5Kg或尺寸超过丰巢寄件服务平台相关业务页面公示或者实际柜机硬件格口尺寸的物品；信函及需本人签收的重要文件；贵重物品（单价超过2万元，若超过，请拆分投放，不能拆分的，请勿投）；生鲜、水果、活物及其他易变质、易腐蚀物品；空包裹；快递公司无法配送地区的包裹等；易碎包裹须提供充分的防破损措施。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        3、寄件人姓名和手机号必须与当前登录账号绑定的实名信息和手机号相同，若寄件人信息和绑定的用户信息不一致的，不可使用本服务。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        4、不得利用本服务从事违法犯罪、侵害他人（含丰巢）合法权益的行为。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        5、不得违反丰巢智能柜的操作规定，损坏、损毁智能柜。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        6、妥善保管寄件码，不得随意泄露，否则责任自担。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:12px;display: block;">
        7、不得实施其他影响丰巢正常经营，造成或将造成丰巢损失的行为。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        五、交易取消费用规则
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        1、在下单过程中，若预定格口失败，预付的费用将于3-7日内原路退回。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        2、您当天预定格口成功后，在投递入柜之前取消订单累积超过3次，从第4次开始，每取消1次，丰巢将扣除0.5元的技术服务费，剩余预付费用将于3-7日内原路退回。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:12px;display: block;">
        3、您支付成功后3日内未进行投递入柜的，订单自动取消，预付费用将于3-7日内原路退回。自动取消的订单消耗当天取消订单免费次数，自动取消订单致当天超出免费取消次数的，按上款约定处理。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        六、服务的变更、中止与终止
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        1、丰巢有权不定期根据有关法律、法规的变化以及公司经营状况和经营策略的调整等修改本服务条款。如本协议内容发生变动，丰巢将通过智能快件箱屏幕、微信公众号等方式或在适用的服务中予以公布。您应当定期查阅本协议条款。如您在本协议内容修改/变更后继续使用本服务，则视为您接受丰巢所做的相关修改。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        2、您若利用账号欺诈、发布虚假消息、实施其他违反本协议要求或中国的相关法律法规的行为的，丰巢有权暂停对您的服务，拒不纠正的，丰巢有权终止服务且无须征得您的同意。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        3、丰巢因系统维护、设备故障或电信部门调整业务等原因将会暂停本服务，但将尽力降低影响。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        4、本服务中止或中断前，您账户中涉及余额或其他资产的，应根据丰巢公布的规则退回、折现或做其他处理。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:12px;display: block;">
        5、丰巢有权经提前通知将本协议的权利义务全部或者部分转移给除丰巢互动媒体有限公司外丰巢的其他关联公司。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        七、责任的承担
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        1、您违反约定或规定给智能柜及其系统造成损害的，应承担赔偿责任。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        2、若您利用本服务从事违法犯罪等行为的，丰巢经监控发现，有权直接向有关部门举报并采取封锁格口等必要措施。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      3、<span style="color: #000000; font-family: 宋体;"
      >您在使用本服务时，如柜内物品发生损害、丢失、被盗等情况，若证实为因丰巢未尽保管义务造成，丰巢的赔付金额在您提供价值证明后以您的实际损失为限；若您无法或不提供价值证明，丰巢将按照您已支付的寄件运费的7-9倍向您赔付；若您违反本协议约定将第四条第2款涉及的包裹放入柜中，该类包裹的损失不在赔偿范围内。
      </span>
    </p>
    <p style="text-indent: 24rpx;margin-bottom:12px;">
      4、<span class="fontb" style="color: #e60012;font-family: 宋体;"
      >当发生快递公司取消订单（含拒绝转单取消、不满足揽收标准取消等）、您投递后取消订单后未取回包裹的情形，丰巢将向您发出取回通知，您明确表示放弃包裹所有权的，丰巢按照您的表示予以处理；若在通知发出之日起超过9日您不予取回的，为保障格口正常运营，丰巢将会清理格口，丰巢将再不对您的包裹承担保管责任。请您及时取回包裹。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        八、免责声明
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span class="fontb" style="color: #000000; font-family: 宋体;display: block;">
        如发生以下情况，丰巢无须承担任何责任：
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span class="fontb" style="color: #000000; font-family: 宋体;display: block;">
        1、若您因为向丰巢提供的信息不准确、不完全、不真实导致无法正常使用本服务、物品运输延误、物品无法送达或遭受其他损失的。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span class="fontb" style="color: #000000; font-family: 宋体;display: block;">
        2、若您因为个人原因导致资料泄露，包括但不限于：与他人共享注册信息、寄件码，手机、银行卡等个人信息丢失的情形。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span class="fontb" style="color: #000000; font-family: 宋体;display: block;">
        3、若您因使用本服务而产生的任何间接性、派生性或扩大性的损失，但法律法规另有规定除外。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span class="fontb" style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        4、若因不可抗力或其他无法控制的因素导致本公司系统或智能柜无法正常使用的情形。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        九、争议解决
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        1、本协议适用中华人民共和国大陆地区法律；如果法律无相关规定的，参照商业惯例和/或行业惯例。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;margin-bottom:12px;display: block;">
        2、您因使用服务所产生和/或与服务有关的争议，双方应及时协商解决；协商不成时，任何一方有权向深圳前海合作区人民法院提起诉讼。
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span class="fontb" style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        丰巢寄件服务主体：
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地址：深圳市前海深港合作区南山街道桂湾五路123号前海大厦T2栋1601
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        法定代表人：徐育斌
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        统一社会信用代码：91440300MA5FQ0TL82
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        深圳市丰巢科技有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地址：深圳市前海深港合作区南山街道临海大道59号海运中心主塔楼1601
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        法定代表人：徐育斌
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        统一社会信用代码：91440300335162247A
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        丰巢互动媒体有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地址：中国（四川）自由贸易试验区成都市高新区天府三街1166号1栋14层1405号
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        法定代表人：徐育斌
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        统一社会信用代码：91510100057499922G
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span class="fontb" style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        丰巢持有的快递经营许可证信息：
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        1、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：潮州、珠海、阳江、东莞、韶关、茂名、梅州、肇庆、中山、湛江、清远、佛山、广州、汕尾、惠州、深圳、汕头、江门、河源、揭阳
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：粤邮20210007B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2026年2月22日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        2、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：安徽丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：合肥、芜湖、蚌埠、淮南、马鞍山、铜陵、安庆、滁州、阜阳、六安、亳州、宜城、宿州
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：皖邮20210014B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2026年2月4日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        3、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：山东丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：滨州、淄博、泰安、济南、烟台、临沂、聊城、青岛、潍坊、枣庄、德州、威海、东营、济宁、日照、菏泽
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：鲁邮20201299B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年7月8日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        4、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：青海丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：西宁
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：青邮20210002B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2026年6月20日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        5、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：甘肃丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：兰州
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：甘邮20200014B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年7月30日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        6、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：内蒙古丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：包头、鄂尔多斯、呼和浩特、赤峰
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：蒙邮20200063B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年11月15日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        7、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：天津丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：天津
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：津邮20200009B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年11月8日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        8、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：江西丰巢信息技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：吉安、九江、抚州、南昌、上饶、宜春、赣州
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：赣邮20210019B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2026年2月1日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        9、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：山西丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：太原、大同、长治、晋中
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：晋邮20200021B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年8月30日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        10、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：贵州丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：遵义、贵阳
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：黔邮20200026B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年7月30日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        11、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：福建丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：福州、南平、厦门、泉州、三明、漳州、龙岩、宁德、莆田
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：闽邮20200013B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年7月5日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        12、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：河南丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：三门峡、洛阳、周口、安阳、商丘、平顶山、漯河、濮阳、郑州、驻马店、信阳、南阳、许昌、新乡、开封、焦作
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：豫邮20200012B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年7月15日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        13、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：北京丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：北京
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：京邮20200207B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年9月22日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        14、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：浙江丰巢物联网技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：杭州、绍兴、湖州、温州、台州、舟山、丽水、宁波、嘉兴、衢州、金华
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：浙邮20200031B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年7月1日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        15、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：海南丰巢信息技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：海南自贸区
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：琼邮20200002B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年6月29日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        16、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：吉林丰巢网络科技有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：长春、吉林
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：吉邮20200032B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年7月30日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        17、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：湖北丰巢物联网技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：鄂州、黄石、襄阳、孝感、武汉、宜昌、荆门、黄冈、荆州、咸宁、十堰
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：鄂邮20200022B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年7月16日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        18、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：湖南丰巢物联网技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：常德、长沙、岳阳、永州、郴州、衡阳、益阳、邵阳、株洲、湘潭、娄底
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：湘邮20200027B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年9月10日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        19、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：广西丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：钦州、贵港、柳州、桂林、玉林、梧州、南宁、北海、金华
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：桂邮20200032B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年8月27日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        20、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：西藏丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：拉萨
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：藏邮20230002B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2028年1月15日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        21、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：辽宁丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：盘锦、鞍山、沈阳、大连、锦州、营口、抚顺
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：辽邮20200033B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年9月26日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        22、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：宁夏丰巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：银川
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：宁邮20200009B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年7月5日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        23、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：江苏丰巢物联网技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：南京、苏州、无锡、常州、镇江、扬州、泰州、南通、徐州、淮安、盐城、连云港、宿迁
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：苏邮20201487B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年5月12日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        24、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：陕西丰巢网络科技有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：渭南、榆林、宝鸡、咸阳、西安
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：陕邮20200590B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年8月31日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        25、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：河北丰巢网络科技有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：秦皇岛、张家口、保定、唐山、廊坊、沧州、衡水、邯郸、承德、邢台、石家庄
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：冀邮20200008B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年8月12日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        26、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：四川丰巢网络科技有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：成都、南充、达州、广元、宜宾、绵阳、德阳、遂宁、眉山、攀枝花、自贡、内江、广安、乐山、泸州
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：川邮20200143B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年11月16日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        27、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：新疆丰巢网络科技有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：乌鲁木齐
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：新邮20210033B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2026年8月9日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        28、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：上海丰巢物联网有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：上海
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：沪邮20202049B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年7月15日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        29、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：云南上巢网络技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：玉溪、曲靖、昆明
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：滇邮20200033B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年11月10日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        30、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：重庆上巢物联网技术有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：重庆
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：渝邮20200009B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; margin-bottom:12px;font-family: 宋体;display: block;">
        有效期至：2025年7月1日
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        31、
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        持证主体：黑龙江丰巢网络科技有限公司
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        业务范围：运营智能快件箱经营快递业务（邮政企业专营业务除外）
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        地域范围：齐齐哈尔、哈尔滨、大庆
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        许可证编号：黑邮20200603B
      </span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;display: block;">
        有效期至：2025年11月3日
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ServiceAgreementFengchao',
  data() {
    return {}
  },
}
</script>

<style scoped lang="scss">
$color999: #999999;
$color333: #333333;
.pages {
  background: #ffffff;
  box-sizing: border-box;
  padding: 16px;
  font-size: 14px;display: block;
  color: $color333;
}
.title {
  text-align: center;
  font-size: 16px;
}

.sub_text {
  text-align: right;
}

.fontb {
  font-weight: bold;
}

th, td {
  padding: 10px;
}
</style>
